import { BlankSlideInsertProvider } from '@/components/canvas/BlankSlideInsertContext';
import { CanvasContainer } from '@/components/canvas/CanvasContainer';
import { EditorDndProvider } from '@/components/canvas/EditorDndProvider';

import { LeftToolbar } from './LeftToolbar';
import { RightPanel } from './RightPanel';

export function MainWorkspace() {
  return (
    <EditorDndProvider>
      <BlankSlideInsertProvider>
        <LeftToolbar />
        <CanvasContainer />
        <RightPanel />
      </BlankSlideInsertProvider>
    </EditorDndProvider>
  );
}
